import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EditorState } from 'draft-js';
import classNames from 'classnames';
import { ComponentRender, ActionContainer, DivOverlay } from './styled';

const getEmbeddedComponent = config =>
  class Embedded extends Component {
    static propTypes = {
      block: PropTypes.object,
      contentState: PropTypes.object,
    };

    state = {
      alignment: 'left',
    };

    setEntityAlignment = (alignment = 'center') => {
      return (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { block, contentState } = this.props;
        const entityKey = block.getEntityAt(0);
        contentState.mergeEntityData(entityKey, { alignment });
        config.onChange(EditorState.push(config.getEditorState(), contentState, 'change-block-data'));
        this.setState({ alignment });
      };
    }

    renderActionFields(alignment = 'left') {
      return (
        <ActionContainer alignment={alignment} className="action-container">
          <div className="action-wrapper">
            {false && (
              <div className="link-edit-wrapper">
                <input type="text" contentEditable="true" />
                <button>
                  <i className="material-icons">edit</i>
                </button>
              </div>
            )}
            <div className="options-wrapper">
              <div
                className={classNames('options', { selected: alignment === 'left' })}
                onClick={this.setEntityAlignment('left')}
              >
                <i className="material-icons">format_align_left</i>
              </div>
              <div
                className={classNames('options', { selected: alignment === 'center' })}
                onClick={this.setEntityAlignment('center')}
              >
                <i className="material-icons">format_align_center</i>
              </div>
              <div
                className={classNames('options', { selected: alignment === 'right' })}
                onClick={this.setEntityAlignment('right')}
              >
                <i className="material-icons">format_align_right</i>
              </div>
            </div>
          </div>
        </ActionContainer>
      );
    }

    render() {
      const { block, contentState } = this.props;
      const entity = contentState.getEntity(block.getEntityAt(0));
      const { src, height, width, alignment = 'center' } = entity.getData();
      return (
        <ComponentRender
          className={classNames('rdw-image-alignment', {
            'rdw-image-left': alignment === 'left' || !alignment || alignment === 'none',
            'rdw-image-right': alignment === 'right',
            'rdw-image-center': alignment === 'center',
          })}
        >
          <span className="rdw-image-imagewrapper">
            <DivOverlay />
            <iframe
              height={height}
              width={width}
              src={src}
              frameBorder="0"
              allowFullScreen
              title="Embedded Content"
            />

            {this.renderActionFields(alignment)}
          </span>
        </ComponentRender>
      );
    }
  };

export default getEmbeddedComponent;
